export const formatModelNumber = modelNumber => {
  if (!modelNumber) {
    return '';
  }
  const splits = modelNumber.split(' ');
  let formattedModelNumber = splits[0];
  if (splits.length > 1) {
    formattedModelNumber += splits[1];
  }
  return formattedModelNumber.replace(/[^a-zA-Z0-9]/g, '');
};
